import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';

import { errorRoutes } from './';

const BASE_LAYOUT_ROUTES = [
    ...errorRoutes
];

@NgModule({
  imports: [
    RouterModule.forRoot(BASE_LAYOUT_ROUTES, { useHash: true })
  ],
  exports: [
    RouterModule
  ]
})
export class LayoutRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/layouts/layout-routing.module.ts